import angular from 'angular';
import ConfigurableLinkWidgetComponent from './configurable-link-widget-component';

export default angular.module('configurable-link-widget', []).component('configurableLinkWidget', new ConfigurableLinkWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/configurable-link/configurable-link-widget-module.js